import React from 'react';
import { st, classes } from './Divider.st.css';
import { DIRECTIONS, SKINS } from './Divider.constants';
import { DividerProps } from './Divider.types';

const Divider = ({
  dataHook,
  className,
  direction = DIRECTIONS.horizontal,
  skin = SKINS.light,
}: DividerProps) => (
  <hr
    data-hook={dataHook}
    className={st(classes.root, { direction, skin }, className)}
  />
);

Divider.displayName = 'Divider';

export { Divider };
